import React, { useEffect, useState } from 'react'
import { ButtonBase, makeStyles } from '@material-ui/core'
import {
  BASE_COLORS,
  GRAY_COLORS,
  PRIMARY_COLORS
} from 'asterX-UI/colors.constant'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 8,
    border: '1px solid ' + GRAY_COLORS[300],
    padding: 10,
    backgroundColor: BASE_COLORS.White,
    gap: 32
  },
  circle: {
    backgroundColor: BASE_COLORS.White,
    width: 16,
    height: 16,
    border: '1px solid ' + GRAY_COLORS[300],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkedCircle: {
    backgroundColor: PRIMARY_COLORS[400],
    width: 12,
    height: 12,
    border: '3px solid ' + GRAY_COLORS[300],
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

const CheckBoxBtn = ({
  checked: value,
  name = '',
  onClick,
  children,
  ...props
}) => {
  const classes = useStyles()
  const [checked, setChecked] = useState(value)
  useEffect(() => {
    setChecked(value)
    return () => {}
  }, [value])

  const handleCheck = () => {
    setChecked(!checked)
    const data = {
      target: {
        name,
        checked: !checked
      }
    }
    onClick?.(data)
  }
  return (
    <ButtonBase className={classes.root} onClick={handleCheck} {...props}>
      {children}{' '}
      <div className={checked ? classes.checkedCircle : classes.circle} />
    </ButtonBase>
  )
}

export default CheckBoxBtn
